__turbopack_context__.v({
  "OrganisationResult": "ILZVZq_OrganisationResult",
  "contact": "ILZVZq_contact",
  "legend": "ILZVZq_legend",
  "location": "ILZVZq_location",
  "noPassersBy": "ILZVZq_noPassersBy",
  "noRegistration": "ILZVZq_noRegistration",
  "passersBy": "ILZVZq_passersBy",
  "registration": "ILZVZq_registration",
  "unknown": "ILZVZq_unknown",
});
